import { render, staticRenderFns } from "./referral_form.vue?vue&type=template&id=1f21d6e0&scoped=true&"
import script from "./referral_form.vue?vue&type=script&lang=js&"
export * from "./referral_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f21d6e0",
  null
  
)

export default component.exports